import { DemandExample } from '../../services/types/demand-example-types';
import { Button } from '../ui/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogDescription,
  DialogTitle,
} from '../ui/catalyst/dialog';

interface DemandExampleDeleteModalProps {
  isOpen: boolean;
  selectedExample: DemandExample | null;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DemandExampleDeleteModal = ({
  isOpen,
  selectedExample,
  isLoading,
  onClose,
  onConfirm,
}: DemandExampleDeleteModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Delete Demand Example</DialogTitle>
      <DialogDescription>
        Are you sure you want to delete &ldquo;
        {selectedExample?.title || 'this example'}&rdquo;? This action cannot be
        undone.
      </DialogDescription>

      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button color="red" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
